export const navMenu = [
    {
        name: 'Services',
        path: '/',
        menu: [
            { name: 'Sedation Dentistry', path: '/services/sedation-dentistry/' },
            { name: 'Family Care Dentistry', path: '/services/family-care-dentistry/' },
            { name: 'Cosmetic Dentistry', path: '/services/cosmetic-dentistry/' },
            { name: 'Restorative Dentistry', path: '/services/restorative-dentistry/' },
            { name: 'Implants Dentistry', path: '/services/implant-dentistry/' },
            { name: 'Invisalign', path: '/services/invisalign/' },
            { name: 'Emergency Dentistry', path: '/services/emergency-dentistry/' },
        ],
    },
    {
        name: 'For Patients',
        menu: [
            { name: 'New Patient Special', path: '/new-patient-special/' },
            { name: 'Insurance & Financing', path: '/insurance-and-financing/' },
            { name: 'Membership Plan', path: '/membership-plans/' },
            { name: 'VIP List', path: '/vip-list/' },
        ],
    },
    {
        name: 'Our Difference',
        path: '/our-difference/',
    },
    {
        name: 'Contact Us',
        path: '/contact-us/',
    },
    {
        name: 'Blog',
        menu: [
            { name: 'Invisalign for Teens', path: '/blog/invisalign-teen/' },
            { name: 'Cosmetic Dentistry Treatment', path: '/blog/5-popular-cosmetic-treatments/' },
            { name: 'Veneers or Crowns?', path: '/blog/veneers-crowns/' },
            { name: 'Smiling Health Effects', path: '/blog/smiling-affects-health/' },
            { name: 'Mouth Ulcers & Canker Sores', path: '/blog/mouth-ulcers-and-canker-sores/' },
            {
                name: '10 Ways to Calm Dental Anxiety ',
                path: '/blog/10-ways-to-calm-dental-anxiety/',
            },
        ],
    },
];
